import { render, staticRenderFns } from "./AttractionItem.vue?vue&type=template&id=0da3946a&"
import script from "./AttractionItem.vue?vue&type=script&lang=js&"
export * from "./AttractionItem.vue?vue&type=script&lang=js&"
import style0 from "./AttractionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports